<link rel="preload" as="image" href="/assets/images/image-placeholder.svg" />

<div #container class="full-height full-width flex-column" [class.builder]="!isPreSelection">
  <ng-container *ngIf="groupedGridOptions">
    <vdw-status-bar
      class="full-width status-bar"
      [statusBar]="statusBar"
      [selectedRows]="getSelectedRows()"
      [gridModel]="groupedGridModel"
      [gridApi]="(groupedGrid.gridReady | async)?.api"
      (updateGrid)="updateGrid($event)"
      (toggleSelected)="toggleSelectedRows($event)"
      [initialToggleSelected]="onlyShowSelected"
      [canShowOnlyShowSelectedToggle]="isPreSelection"
    >
      <div class="status-bar-buttons">
        <vdw-dialog-button
          *ngIf="!isPreSelection"
          #customSettingsButton
          [componentType]="customSettingsComponent"
          [dialogData]="getCustomSettingsDialogData()"
          (dialogDataChanged)="onCustomSettingsChanged($event)"
        >
          <button mat-icon-button class="mat-icon-action-button-lg-with-border" [class.open]="customSettingsButton.open" (click)="customSettingsButton.toggleDialog()">
            <mat-icon svgIcon="settings"></mat-icon>
          </button>
        </vdw-dialog-button>

        <mat-form-field class="no-subscript view-mode-selector">
          <mat-select [value]="selectedViewMode" (selectionChange)="onSelectedViewModeChanged($event.value)" disableOptionCentering>
            <mat-option *ngFor="let viewMode of viewModes" [value]="viewMode" [matTooltip]="getTooltip('PRODUCTION_ORDER.DESIGN_LIBRARY.VIEW_MODES.' + viewMode)">{{
              'PRODUCTION_ORDER.DESIGN_LIBRARY.VIEW_MODES.' + viewMode | bmsTranslate
            }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div></vdw-status-bar
    >

    <ag-grid-angular #groupedGrid class="ag-theme-vdw full-width ag-grid-compact-view" [class.loading]="loadingForTheFirstTime" [gridOptions]="groupedGridOptions"></ag-grid-angular>
  </ng-container>
</div>
